<script lang="ts">
  import { isEmpty } from "lodash";
  import BannerComponent from "@shared/svelte/Components/Banner/Banner.svelte";
  import FulfillmentMethodPicker from "@retailer/svelte/Shared/FulfillmentMethodPicker.svelte";
  import ProductListCard from "@shared/svelte/Components/ProductLines/ProductListCard.svelte";
  import ShoppableUnit from "@shared/svelte/Components/ShoppableUnit/ShoppableUnit.svelte";
  import { sortingRequiresLessAds } from "@shared/types/ProductLinesSortOptions";
  import { hideFulfillmentMethodPickerForDistributor } from "@retailer/services/fulfillment_methods_service";

  import type { ProductLine, Product } from "@shared/types/ProductLine";
  import type { ProductIndexBanner } from "@shared/types/ProductIndexBanner";
  import type { ShoppableUnit as ShoppableUnitType } from "@shared/types/ShoppableUnit";
  import type { Distributor } from "@shared/types/Distributor";

  export let productLines: ProductLine[];
  export let Cart = null;
  export let banners: ProductIndexBanner[] = [];
  export let shoppableUnit: ShoppableUnitType | any = {};
  export let stateParams: any;
  export let mobileMode: boolean;

  let banner: ProductIndexBanner = banners[0];
  let bannerIndex;
  let fulfillmentMethodPickerDistributor;
  let fulfillmentMethodPickerProductLine;
  let fulfillmentMethodPickerProducts;
  let fulfillmentMethodPickerSku: string = null;
  let shoppableUnitIndex;
  let showFulfillmentMethodsDrawer: boolean = false;

  $: {
    if (!isEmpty(shoppableUnit) && !mobileMode) {
      bannerIndex = 12;
      shoppableUnitIndex = 5;
    } else if (!isEmpty(shoppableUnit) && mobileMode) {
      bannerIndex = 8;
      shoppableUnitIndex = 4;
    } else {
      bannerIndex = mobileMode ? 4 : 5;
    }
  }

  const setupAds = productLines => {
    const ads = productLines.filter(productLine => productLine.is_paid);
    const nonAds = productLines.filter(productLine => !productLine.is_paid);

    const firstAds = ads.slice(0, 2);
    const secondAds = ads.slice(2);
    const firstNonAds = nonAds.slice(0, 4);
    const secondNonAds = nonAds.slice(4);

    // When sorting by price or newly added, only show up to 2 ads, always at the beginning of the results.
    // With all other sort options, stagger the ads.
    if (sortingRequiresLessAds(stateParams?.product_sort)) {
      return [...firstAds, ...nonAds];
    } else {
      return [...firstAds, ...firstNonAds, ...secondAds, ...secondNonAds];
    }
  };

  function openFulfillmentMethodsDrawer(
    e: CustomEvent<{
      distributor: Distributor;
      productLine: ProductLine;
      products: Product[];
      sku: string | null;
    }>,
  ): void {
    fulfillmentMethodPickerDistributor = e.detail.distributor;
    fulfillmentMethodPickerProductLine = e.detail.productLine;
    fulfillmentMethodPickerProducts = e.detail.products;
    fulfillmentMethodPickerSku = e.detail.sku;
    showFulfillmentMethodsDrawer = true;
  }

  const getProductLineSkus = (productLine: ProductLine) =>
    productLine.products.map(p => p.inventory[0].sku);
</script>

<div class="product-line-list" data-testid="product-line-list">
  {#each setupAds(productLines) as productLine, index}
    {#if index === shoppableUnitIndex}
      <div data-testid={`shoppable-list-index-${index}`}>
        <ShoppableUnit {shoppableUnit} />
      </div>
    {/if}
    {#if banner && index === bannerIndex}
      <div class="banner-in-list" data-testid={`banner-list-index-${index}`}>
        <BannerComponent banners={banner.banners} {mobileMode} />
      </div>
    {/if}
    <ProductListCard
      {productLine}
      {index}
      hidePrice={false}
      {stateParams}
      {Cart}
      on:openDrawer={openFulfillmentMethodsDrawer}
    />
  {/each}
</div>
{#if fulfillmentMethodPickerDistributor && !hideFulfillmentMethodPickerForDistributor(fulfillmentMethodPickerDistributor?.distributor_id)}
  <FulfillmentMethodPicker
    bind:open={showFulfillmentMethodsDrawer}
    distributor={fulfillmentMethodPickerDistributor}
    products={fulfillmentMethodPickerProducts}
    skus={fulfillmentMethodPickerSku
      ? [fulfillmentMethodPickerSku]
      : getProductLineSkus(fulfillmentMethodPickerProductLine)}
    forProductLine={fulfillmentMethodPickerSku ? false : true}
  />
{/if}
